// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const fa: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'چگونه بازی کنیم',
  'howto.pieces.heading': 'قطعه‌ها',
  'howto.pieces.source': 'منبع',
  'howto.pieces.mirror': 'آینه',
  'howto.pieces.switch': 'کلید',
  'howto.pieces.exit': 'خروج',
  'howto.pieces.wall': 'دیوار',
  'howto.controls.heading': 'کنترل‌ها',
  'howto.controls.clickSlot.line1': 'روی جای آینه کلیک کن',
  'howto.controls.clickSlot.line2': 'آینه را بگذار',
  'howto.controls.dragMirror.line1': 'آینه را بکش',
  'howto.controls.dragMirror.line2': 'بچرخان',
  'howto.controls.rightClick.line1': 'کلیک راست',
  'howto.controls.rightClick.line2': 'آینه را بردار',
  'howto.controls.hint': 'چرخ ماوس: چرخش ظریف ۱°.   ضربه روی آینه: چرخش ۱۵°.',
  'howto.objective.line1': 'هر کلید را روشن کن — قفل خروج خود به خود باز می‌شود.',
  'howto.objective.line2': 'سپس روی خروج کلیک کن. با کمترین آینهٔ ممکن حل کن.',

  'howtoColor.title': 'رنگ و منشور',
  'howtoColor.pieces.heading': 'قطعات جدید',
  'howtoColor.pieces.prism': 'منشور',
  'howtoColor.pieces.redSwitch': 'کلید قرمز',
  'howtoColor.pieces.yellowSwitch': 'کلید زرد',
  'howtoColor.pieces.whiteSwitch': 'کلید سفید',
  'howtoColor.how.heading': 'چگونه کار می‌کنند',
  'howtoColor.how.line1': 'پرتوی سفید نور قرمز، سبز و آبی را یک‌جا حمل می‌کند.',
  'howtoColor.how.line2': 'منشور نور سفید را در سه ضلع خود به سه پرتوی رنگی تقسیم می‌کند.',
  'howtoColor.how.line3': 'روی منشورِ گذاشته‌شده کلیک کن تا وجه ورودی‌اش بچرخد.',
  'howtoColor.switches.line1': 'کلیدها نقطه‌های رنگی نشان می‌دهند — همان رنگی است که می‌خواهند.',
  'howtoColor.switches.line2': 'کلید زرد (نقطه‌های قرمز + سبز) به هر دو رنگ هم‌زمان نیاز دارد.',
  'howtoColor.switches.line3': 'کلید سفید (هر سه رنگ) به قرمز، سبز و آبی هم‌زمان نیاز دارد.',

  'options.hints.label': 'نمایش زوایای راهنما در پازل‌ها',
  'options.hints.help': 'زاویهٔ بین پرتوی ورودی و پرتوی بازتاب‌یافته را در هر برخورد نشان می‌دهد.',

  'level.01-intro.title': 'سلام نور',
  'level.02-two-mirrors.title': 'دو پیچ',
  'level.03-corner.title': 'دیوار سر راه',
  'level.04-two-targets.title': 'دو هدف',
  'level.05-tight.title': 'تنگ',
  'level.06-hello-color.title': 'سلام رنگ',
  'level.07-pick-a-side.title': 'یک طرف را انتخاب کن',
  'level.08-yellow.title': 'زرد',
  'level.09-magenta.title': 'سرخابی',
  'level.10-spectrum.title': 'طیف',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'قائمه',
  'puzzle.hint.angleType.acute': 'حاده',
  'puzzle.hint.angleType.obtuse': 'منفرجه',
  'puzzle.hint.label': '{angle}°\n{type}',
};
